import exifr from "exifr";
import { fotoApi } from "./fotoApi";

export const DEFAULT_STAMP = { on: false, foto_on: false, pos: "br", fmt: "dt", color: "#ffffff" };
export const loadStampPrefs = () => fotoApi.get("/stamp-prefs").then(({ data }) => ({ ...DEFAULT_STAMP, ...data }));
export const saveStampPrefs = (prefs) => fotoApi.patch("/stamp-prefs", prefs).then(({ data }) => data);

const fmtStamp = (d, fmt) => {
  const p = (n) => String(n).padStart(2, "0");
  const ds = `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`, ts = `${p(d.getHours())}:${p(d.getMinutes())}`;
  return fmt === "d" ? ds : fmt === "t" ? ts : `${ds} ${ts}`;
};

const shotDate = async (file) => {
  try {
    const dt = (await exifr.parse(file, ["DateTimeOriginal"]))?.DateTimeOriginal;
    return dt instanceof Date && !isNaN(dt.getTime()) ? dt : new Date();
  } catch { return new Date(); }
};

// Timbra data/ora sulla foto (stesso stile della finestra Allegati) e la restituisce in JPG.
export async function stampImageFile(file, prefs) {
  if (!/^image\/(jpeg|jpg|png|webp)$/i.test(file.type || "")) return file;
  try {
    const text = fmtStamp(await shotDate(file), prefs.fmt);
    const img = await createImageBitmap(file);
    const w = img.width, h = img.height;
    const canvas = document.createElement("canvas");
    canvas.width = w; canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, w, h);
    const pos = prefs.pos || "br";
    const fs = Math.max(14, Math.round(Math.min(w, h) * 0.045));
    const m = Math.round(fs * 0.8);
    ctx.font = `normal ${fs}px Arial, sans-serif`;
    ctx.textAlign = pos.endsWith("r") ? "right" : "left";
    ctx.textBaseline = pos.startsWith("t") ? "top" : "bottom";
    const x = pos.endsWith("r") ? w - m : m, y = pos.startsWith("t") ? m : h - m;
    ctx.shadowColor = "rgba(0,0,0,0.85)"; ctx.shadowBlur = Math.round(fs * 0.25); ctx.shadowOffsetX = 2; ctx.shadowOffsetY = 2;
    ctx.lineWidth = Math.max(2, Math.round(fs * 0.12)); ctx.strokeStyle = "rgba(0,0,0,0.7)"; ctx.strokeText(text, x, y);
    ctx.shadowBlur = 0; ctx.fillStyle = prefs.color || "#ffffff"; ctx.fillText(text, x, y);
    const blob = await new Promise((r) => canvas.toBlob(r, "image/jpeg", 0.92));
    if (!blob) return file;
    const base = (file.name || "foto").replace(/\.[^.]+$/, "");
    return new File([blob], `${base}.jpg`, { type: "image/jpeg", lastModified: Date.now() });
  } catch { return file; }
}
